(() => {
  const id = "xencms:views-view--guide-cats--sidebar";

  Drupal.behaviors[id] = { attach: (context, settings) => {
    once(id, ".views-view--guide-cats--sidebar", context).forEach((view) => {
      view.querySelectorAll(".views-row").forEach(row => {
        const a = row.querySelector("a");
        if (!(a instanceof Element)) return;

        const isActive = a.getAttribute("href") === window.location.pathname;
        row.classList.toggle("is-active", isActive);
      });
    });
  }};
})();
